import PropTypes from 'prop-types';
import MedicalProviderList from './MedicalProviderList';
import NewMedicalProvider from './NewMedicalProvider';
import AllProvidersBucket from './AllProvidersBucket';
import IncludeIcd from '../IncludeIcd';
import useMedicalProvidersInputMode from '../../hooks/useMedicalProvidersInputMode';
import ProviderModeToggleButton from './ProviderModeToggleButton';

const MedicalProviderSec = ({ providerType, heading }) => {
  const isPostAccident = providerType === 'postAccident';
  const { isAiMode} = useMedicalProvidersInputMode(isPostAccident);

  return (
    <>
      {heading && (
        <div className="flex justify-between items-center w-full! mr-4! mb-4">
          <h2>{heading}</h2>
          <div className="flex items-center gap-3">
            {isPostAccident && <IncludeIcd />}
            <ProviderModeToggleButton isPostAccident={isPostAccident}/>
          </div>
        </div>
      )}
      <MedicalProviderList providerType={providerType} />
      {isAiMode ? (
        <AllProvidersBucket providerType={providerType} />
      ) : (
        <NewMedicalProvider providerType={providerType} />
      )}
    </>
  );
};

MedicalProviderSec.propTypes = {
  providerType: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
};

export default MedicalProviderSec;
